var headers = {
    "content-type": "application/json;charset=UTF-8",
    "token":''
}
module.exports = {headers}


// WEBPACK FOOTER //
// ./src/config/ipConfig.js